export type ApiError = { error: { code: string; message: string; requestId: string; retryable: boolean; issues?: Array<{ path?: string; message: string; code?: string; itemId?: number }> } };

function cookie(name: string) {
  return document.cookie.split("; ").find((item) => item.startsWith(`${name}=`))?.split("=").slice(1).join("=") || "";
}

export async function api<T>(pathname: string, init: RequestInit = {}): Promise<T> {
  const headers = new Headers(init.headers);
  if (init.body && !headers.has("content-type")) headers.set("content-type", "application/json");
  if (init.method && !["GET", "HEAD"].includes(init.method.toUpperCase())) headers.set("x-csrf-token", decodeURIComponent(cookie("__Host-skyboxy_csrf") || cookie("skyboxy_csrf")));
  const response = await fetch(pathname, { ...init, headers, credentials: "same-origin" });
  const payload = await response.json().catch(() => ({ error: { code: "invalid_response", message: "The server returned an unreadable response", requestId: "unknown", retryable: true } }));
  if (!response.ok) throw payload as ApiError;
  return payload as T;
}
